import { useQuery } from 'react-query';
import {
  getBettieFeedPosts,
  type GetBettieFeedPostsQuery,
  type GetBettieFeedPostsResponse
} from '../../services/bettieFeedService';

export function useGetBettieFeedPosts(
  chatRoomId: string,
  query: GetBettieFeedPostsQuery = { page: 1, per_page: 30 }
) {
  return useQuery<GetBettieFeedPostsResponse, Error>(
    ['bettieFeedPosts', chatRoomId, query.page, query.per_page],
    () => getBettieFeedPosts(chatRoomId, query),
    {
      enabled: !!chatRoomId,
      staleTime: 30 * 1000,
      cacheTime: 2 * 60 * 1000
    }
  );
}
